/**
 * GDS ヘッダー - JavaScript
 * ============================================================================
 */

const GDSHeader = {
  // アコーディオン開閉時の自動リサイズ用監視情報
  _accordionWatchers: new WeakMap(),
  /**
   * 初期化
   */
  init() {
    // bodyにヘッダー用のクラスを追加
    document.body.classList.add('has-gds-header');
    
    // ヘッダーの高さを計測して適用
    this.adjustHeaderOffset();
    
    this.bindMegaMenuEvents();
    this.bindDrawerEvents();
    this.bindAccordionEvents();
    this.bindSearchEvents();
    this.bindScrollEvents();
    this.bindResizeEvents();
  },

  /**
   * ヘッダーの高さを計測してbodyのpadding-topに適用
   */
  adjustHeaderOffset() {
    const header = document.querySelector('.gds-header');
    if (!header) return;

    // ヘッダーの実際の高さを取得（ポイントバー含む）
    const headerHeight = header.offsetHeight;
    
    // bodyのpadding-topに設定
    document.body.style.paddingTop = `${headerHeight}px`;
    // CSS変数に実測ヘッダー高を反映（メガメニューのmax-height計算用）
    document.documentElement.style.setProperty('--gds-current-header-height', `${headerHeight}px`);
  },

  /**
   * リサイズイベントの設定
   */
  bindResizeEvents() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.adjustHeaderOffset();
      }, 100);
    });
  },

  /**
   * PCメガメニューのイベント設定（クリックのみ）
   */
  bindMegaMenuEvents() {
    const navItems = document.querySelectorAll('.gds-header__nav-item--mega');
    if (!navItems.length) return;

    navItems.forEach(item => {
      const megaMenu = item.querySelector('.gds-megamenu');
      const navLink = item.querySelector('.gds-header__nav-link');
      if (!megaMenu || !navLink) return;

      // クリックでトグル
      navLink.addEventListener('click', (e) => {
        e.preventDefault();
        
        const isActive = item.classList.contains('is-active');
        
        if (isActive) {
          // すでに開いている場合は閉じる
          this.hideMegaMenu(item);
        } else {
          // 閉じている場合は開く
          this.showMegaMenu(item);
        }
      });

      // メガメニュー内の「閉じる」ボタン
      const closeBtn = megaMenu.querySelector('.gds-megamenu__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.hideMegaMenu(item);
          try { navLink.focus(); } catch (_) {}
        });
      }
    });

    // ページの他の場所をクリックしたら閉じる
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.gds-header__nav-item--mega')) {
        this.hideAllMegaMenus();
      }
    });

    // ESCキーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.hideAllMegaMenus();
      }
    });
  },

  /**
   * メガメニューを表示
   */
  showMegaMenu(item) {
    const megaMenu = item.querySelector('.gds-megamenu');
    if (megaMenu) {
      // 他のメガメニューを閉じる
      this.hideAllMegaMenus();
      
      megaMenu.classList.add('is-active');
      item.classList.add('is-active');
      document.body.classList.add('gds-megamenu-active');
    }
  },

  /**
   * メガメニューを非表示
   */
  hideMegaMenu(item) {
    const megaMenu = item.querySelector('.gds-megamenu');
    if (megaMenu) {
      megaMenu.classList.remove('is-active');
      item.classList.remove('is-active');
      
      // すべてのメガメニューが閉じているかチェック
      const anyActive = document.querySelector('.gds-megamenu.is-active');
      if (!anyActive) {
        document.body.classList.remove('gds-megamenu-active');
      }
    }
  },

  /**
   * すべてのメガメニューを非表示
   */
  hideAllMegaMenus() {
    const activeMenus = document.querySelectorAll('.gds-megamenu.is-active');
    const activeItems = document.querySelectorAll('.gds-header__nav-item--mega.is-active');
    
    activeMenus.forEach(menu => menu.classList.remove('is-active'));
    activeItems.forEach(item => item.classList.remove('is-active'));
    document.body.classList.remove('gds-megamenu-active');
  },

  /**
   * SPドロワーメニューのイベント設定
   */
  bindDrawerEvents() {
    const menuBtn = document.querySelector('.gds-header__menu-btn');
    const drawer = document.querySelector('.gds-drawer');
    const overlay = document.querySelector('.gds-drawer__overlay');
    const closeBtn = document.querySelector('.gds-drawer__close');

    if (!menuBtn || !drawer) return;

    // メニューボタンクリックで開く
    menuBtn.addEventListener('click', () => {
      this.openDrawer();
    });

    // オーバーレイクリックで閉じる
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.closeDrawer();
      });
    }

    // 閉じるボタンクリックで閉じる
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.closeDrawer();
      });
    }

    // ESCキーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        this.closeDrawer();
      }
    });
  },

  /**
   * ドロワーを開く
   */
  openDrawer() {
    const drawer = document.querySelector('.gds-drawer');
    const menuBtn = document.querySelector('.gds-header__menu-btn');
    
    if (drawer) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      
      if (menuBtn) {
        menuBtn.setAttribute('aria-expanded', 'true');
      }
    }
  },

  /**
   * ドロワーを閉じる
   */
  closeDrawer() {
    const drawer = document.querySelector('.gds-drawer');
    const menuBtn = document.querySelector('.gds-header__menu-btn');
    
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      
      if (menuBtn) {
        menuBtn.setAttribute('aria-expanded', 'false');
      }
    }
  },

  /**
   * アコーディオンメニューのイベント設定
   */
  bindAccordionEvents() {
    const accordionToggles = document.querySelectorAll('.gds-drawer__accordion-toggle');
    if (!accordionToggles.length) return;

    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(toggle);
      });
    });
  },

  /**
   * アコーディオンの開閉
   */
  toggleAccordion(toggle) {
    const parent = toggle.closest('.gds-drawer__accordion');
    if (!parent) return;

    const content = parent.querySelector('.gds-drawer__accordion-content');
    if (!content) return;

    const isOpen = parent.classList.contains('is-open');
  

    // トグル
    if (!isOpen) {
      parent.classList.add('is-open');
      content.style.maxHeight = content.scrollHeight + 'px';
      toggle.setAttribute('aria-expanded', 'true');
      // 開いた後に画像読み込みや内容変化で高さを追従
      this.setupAccordionAutoResize(parent, content);
    } else {
      parent.classList.remove('is-open');
      content.style.maxHeight = '0';
      toggle.setAttribute('aria-expanded', 'false');
      // 閉じたら監視を解除
      this.teardownAccordionAutoResize(parent, content);
    }
  },
  
  /**
   * アコーディオン開状態で内容サイズの変化に合わせてmax-heightを更新
   */
  setupAccordionAutoResize(parent, content) {
    // 既に設定済みなら何もしない
    if (this._accordionWatchers.get(content)) return;
    
    const recalc = () => {
      if (!parent.classList.contains('is-open')) return;
      content.style.maxHeight = content.scrollHeight + 'px';
    };
    
    // ResizeObserver が使える場合は要素のサイズ変化を監視
    let ro = null;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(recalc);
      ro.observe(content);
    }
    
    // 画像読み込みによる高さ変化も補足（古い環境や画像単体の変化対策）
    const images = Array.from(content.querySelectorAll('img'));
    const onImgLoad = () => recalc();
    images.forEach(img => img.addEventListener('load', onImgLoad, { passive: true }));
    
    // 直後にも一度再計算（キャッシュ済み画像など）
    recalc();
    
    this._accordionWatchers.set(content, { ro, images, onImgLoad });
  },
  
  /**
   * 自動リサイズ監視を解除
   */
  teardownAccordionAutoResize(parent, content) {
    const watcher = this._accordionWatchers.get(content);
    if (!watcher) return;
    
    if (watcher.ro) {
      try { watcher.ro.disconnect(); } catch (e) {}
    }
    if (watcher.images && watcher.onImgLoad) {
      watcher.images.forEach(img => {
        try { img.removeEventListener('load', watcher.onImgLoad); } catch (e) {}
      });
    }
    this._accordionWatchers.delete(content);
  },

  /**
   * 検索イベントの設定
   */
  bindSearchEvents() {
    const searchBtn = document.querySelector('.js-search-header');
    const searchContainer = document.querySelector('.site-header__search-container');
    const closeSearch = document.querySelector('#SearchClose');
    
    if (searchBtn && searchContainer) {
      // 検索ボタンクリックでモーダルを開く
      searchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.openSearch();
      });
    }

    // 閉じるボタンクリックで閉じる
    if (closeSearch) {
      closeSearch.addEventListener('click', () => {
        this.closeSearch();
      });
    }

    // オーバーレイまたは検索エリア外クリックで閉じる
    document.addEventListener('click', (e) => {
      if (document.body.classList.contains('search-is-active')) {
        const searchArea = document.querySelector('.site-header__search');
        // 検索エリアの外側をクリックした場合
        if (searchArea && !searchArea.contains(e.target) && !e.target.closest('.js-search-header')) {
          this.closeSearch();
        }
      }
    });

    // ESCキーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchContainer && searchContainer.classList.contains('is-active')) {
        this.closeSearch();
      }
    });
  },

  /**
   * 検索モーダルを開く
   */
  openSearch() {
    const searchContainer = document.querySelector('.site-header__search-container');
    if (searchContainer) {
      searchContainer.classList.add('is-active');
      document.body.classList.add('search-is-active');
      
      const searchInput = searchContainer.querySelector('.site-header__search-input');
      if (searchInput) {
        setTimeout(() => searchInput.focus(), 100);
      }
    }
  },

  /**
   * 検索モーダルを閉じる
   */
  closeSearch() {
    const searchContainer = document.querySelector('.site-header__search-container');
    if (searchContainer) {
      searchContainer.classList.remove('is-active');
      document.body.classList.remove('search-is-active');
    }
  },

  /**
   * スクロールイベントの設定
   */
  bindScrollEvents() {
    let lastScrollTop = 0;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      // 以前はスクロールでメガメニューを閉じていたが、要求により無効化
      
      lastScrollTop = currentScroll;
    }, { passive: true });
  }
};

// DOMContentLoaded時に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    GDSHeader.init();
  });
} else {
  GDSHeader.init();
}

// グローバルに公開（必要に応じて）
window.GDSHeader = GDSHeader;

